import { string } from 'prop-types'
import Uploader from '.'

const LinkUploader = (props) => <Uploader {...props} type="link" />

LinkUploader.propTypes = {
  iconName: string,
  promptText: string,
}

LinkUploader.defaultProps = {
  iconName: null,
  promptText: 'Upload',
}

export default LinkUploader
